import { useEffect } from "react";
import { IoIosArrowUp } from "react-icons/io";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <IoIosArrowUp style={{position: 'fixed', bottom: '8px', right: '7px', cursor: 'pointer', zIndex: '999', backgroundColor: '#369dc9', borderRadius: '50%', color: 'white', padding: '6px', width: '28px', height: '28px', fontWeight: 'bold'}} onClick={() => window.scrollTo(0, 0)}/>
  );
};